import './DashboardCard.css';
import EVStationIcon from '../../../assets/icons/station.svg?react';
import { useMemo } from 'react';

const EVStationCard = ({ colSpan = 1, rowSpan = 1, dashboardData = {} }) => {
  const { drResourceData } = dashboardData;
  
  // DR 자원 데이터에서 충전소 수 계산
  const stationCount = useMemo(() => {
    if (!drResourceData?.Items || drResourceData.Items.length === 0) {
      return 0;
    }
    const drResource = drResourceData.Items[0];
    return drResource?.Stations?.length || 0;
  }, [drResourceData]);
  
  return (
    <div 
      className="dashboard-card flex flex-col justify-between" 
    >
      <div className="icon-container icon-green">
        <EVStationIcon/>
      </div>
      <div className="dashboard-card-content flex flex-col gap-10">
        <h3 className="text-b1-700 text-gray-600">할당된 EV 충전소</h3>
        <p className="text-h1 text-base">{stationCount}</p>
      </div>
    </div>
  );
};

export default EVStationCard;
